module.exports = __webpack_public_path__ + "static/media/notfound.334ac9b0.svg";